import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import {
	postResourceModule,
	updateResourceModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

interface Method {
	name: string;
}

interface translateModalSource {
	tittle: string;
	tittleUpdate: string;
	resourceName: string;
	placeholderName: string;
	nameRequired: string;
	path: string;
	placeholderPath: string;
	pathRequired: string;
	actions: string;
	placeholderActions: string;
	actionsRequired: string;
	buttonSave: string;
	buttonCancel: string;
}
interface DataResource {
	type: string;
	resource: Resource;
	module: Module;
}
@Component({
	selector: 'app-modal-add-resource',
	templateUrl: './modal-add-resource.component.html',
	styleUrls: ['./modal-add-resource.component.scss'],
})
export class ModalAddResourceComponent implements OnInit, OnDestroy {
	params: any;
	item: any;
	title = 'Add resource';
	methods: Method[] = [
		{ name: 'GET' },
		{ name: 'POST' },
		{ name: 'PUT' },
		{ name: 'PATCH' },
		{ name: 'DELETE' },
	];
	translateModal: translateModalSource = {} as translateModalSource;
	subscriptionTranslate!: Subscription;
	formResource!: FormGroup;
	constructor(
		private store: Store,
		public dialogRef: MatDialogRef<ModalAddResourceComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DataResource,
		private formBuilder: FormBuilder,
		private translate: TranslateService
	) {}

	ngOnInit(): void {
		this.dataTranslate();
		this.dataForm();
	}

	dataForm() {
		this.formResource = this.formBuilder.group({
			name: [this.data.resource.name, [Validators.required]],
			path: [this.data.resource.path, [Validators.required]],
			action: [{ name: this.data.resource.action }, [Validators.required]],
		});
	}
	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.systemModules.modalResource;
		});
	}
	get f() {
		return this.formResource.controls;
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	save() {
		if (this.formResource.valid) {
			const resource: Resource = {
				name: this.formResource.value.name.toLowerCase().trim(),
				path: this.formResource.value.path.toLowerCase().trim(),
				action: this.formResource.value.action.name.trim(),
			} as Resource;
			if (this.data.type === 'edit') {
				this.store.dispatch(
					updateResourceModule({ pk: this.data.resource.pk, sk: this.data.resource.sk, resource })
				);
			} else {
				this.store.dispatch(
					postResourceModule({ pk: this.data.module.pk, sk: this.data.module.sk, resource })
				);
			}
			this.onNoClick();
		}
	}
	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
